/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ContactSidebar.css';
import fetch from '../../core/fetch';
import $ from 'jquery';
import { Link } from 'react-router';


@withStyles(s)
export default class ContactSidebar extends Component{

    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    componentDidMount(){
        
        
    }

    render(){

        var content =   <div className={`contactSidebar`}>
                            <span className={`titreSectionSidebar`}>Contactez-nous</span>
                            <div className={`content`}>
                                <span className={`texteContact`}>Demandez votre consultation gratuite !</span>
                                <div className={`btnSidebar`}>
                                    <Link to="/contact">Consultation</Link>
                                </div>
                            </div>
                            <div className={`content`}>
                                <span className={`texteContact`}>Demandez un audit de votre site web !</span>
                                <div className={`btnSidebar`}>
                                    <Link to="/contact">Audit</Link>
                                </div>
                            </div>
                        </div>
                        
       
        return (
            <div className={s.root}>
                {content}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/ContactSidebar/ContactSidebar.js